"use strict";

/*==============================================================================*
*TRESTLE™ W004
*POPUP TOOL — FOOD GI CALCULATOR
*==============================================================================*/

window.TRESTLE_W004_TOOLS =
window.TRESTLE_W004_TOOLS || {};


window.TRESTLE_W004_TOOLS.food_gi_calculator = {


/*==============================================================================*
*RENDER
*==============================================================================*/

render(){

    return `

    <div class="tr-w004-gi-tool">

        <div class="gi-calculator">


            <p class="gi-intro">

                Explore the estimated glycemic impact of selected foods
                based on portion size.

            </p>


            <label>

                Select Food

            </label>


            <select data-gi-food>

                <option value="brown_rice">
                    Brown Rice
                </option>

                <option value="white_rice">
                    White Rice
                </option>

                <option value="whole_wheat_roti">
                    Whole Wheat Roti
                </option>

                <option value="banana">
                    Banana
                </option>

                <option value="apple">
                    Apple
                </option>

                <option value="chickpeas">
                    Chickpeas
                </option>

                <option value="idli">
                    Idli
                </option>

                <option value="poha">
                    Poha
                </option>

                <option value="sweet_potato">
                    Sweet Potato
                </option>

                <option value="watermelon">
                    Watermelon
                </option>

            </select>


            <label>

                Quantity (g)

            </label>


            <input
            type="number"
            min="1"
            placeholder="e.g. 100"
            data-gi-quantity>


            <div class="gi-button-row">


                <button
                type="button"
                class="gi-primary-btn"
                data-gi-calculate>

                    Check GI

                </button>


                <button
                type="button"
                class="gi-clear-btn"
                data-gi-clear>

                    Clear

                </button>


            </div>


            <div
            class="gi-result-box"
            data-gi-result
            hidden>
            </div>


            <div class="gi-disclaimer">

                Glycemic index and glycemic load values are general
                educational estimates and may vary depending on food
                preparation, portion size and individual response.

            </div>


        </div>

    </div>

    `;

},


/*==============================================================================*
*INIT
*==============================================================================*/

init(root){

    if(!root){

        return;

    }


/*==============================================================================*
*FOOD DATA
*==============================================================================*/

    const foodData = {

        brown_rice:{
            gi:50,
            carbsPer100g:30
        },

        white_rice:{
            gi:72,
            carbsPer100g:28
        },

        whole_wheat_roti:{
            gi:62,
            carbsPer100g:45
        },

        banana:{
            gi:52,
            carbsPer100g:23
        },

        apple:{
            gi:38,
            carbsPer100g:14
        },

        chickpeas:{
            gi:28,
            carbsPer100g:27
        },

        idli:{
            gi:65,
            carbsPer100g:28
        },

        poha:{
            gi:69,
            carbsPer100g:28
        },

        sweet_potato:{
            gi:44,
            carbsPer100g:20
        },

        watermelon:{
            gi:72,
            carbsPer100g:8
        }

    };


/*==============================================================================*
*DOM
*==============================================================================*/

    const foodSelect =

        root.querySelector(

            "[data-gi-food]"

        );


    const quantityInput =

        root.querySelector(

            "[data-gi-quantity]"

        );


    const calculateButton =

        root.querySelector(

            "[data-gi-calculate]"

        );


    const clearButton =

        root.querySelector(

            "[data-gi-clear]"

        );


    const resultBox =

        root.querySelector(

            "[data-gi-result]"

        );


    if(

        !foodSelect ||
        !quantityInput ||
        !calculateButton ||
        !clearButton ||
        !resultBox

    ){

        return;

    }


/*==============================================================================*
*CALCULATE
*==============================================================================*/

    const calculateGI = ()=>{


        const item =

            foodSelect.value;


        const quantity =

            parseFloat(

                quantityInput.value

            );


        if(

            isNaN(quantity) ||
            quantity <= 0

        ){

            resultBox.innerHTML =

                "Please enter a valid quantity.";


            resultBox.hidden = false;


            return;

        }


        const food =

            foodData[item];


        if(!food){

            return;

        }


        const carbs =

            (quantity / 100) *

            food.carbsPer100g;


        const glycemicLoad =

            (

                food.gi *

                carbs

            ) / 100;


        let category =

            "Low";


        if(glycemicLoad > 20){

            category =

                "High";

        }

        else if(glycemicLoad > 10){

            category =

                "Moderate";

        }


/*==============================================================================*
*RESULT
*==============================================================================*/

        resultBox.innerHTML = `

            <h4>

                Estimated Glycemic Impact

            </h4>


            <div class="gi-result-grid">


                <div>

                    <span>GI</span>

                    <strong>

                        ${food.gi}

                    </strong>

                </div>


                <div>

                    <span>Carbohydrates</span>

                    <strong>

                        ${carbs.toFixed(1)} g

                    </strong>

                </div>


                <div>

                    <span>Glycemic Load</span>

                    <strong>

                        ${glycemicLoad.toFixed(1)}

                    </strong>

                </div>


                <div>

                    <span>Impact</span>

                    <strong>

                        ${category}

                    </strong>

                </div>


            </div>

        `;


        resultBox.hidden = false;


        resultBox.scrollIntoView({

            behavior:"smooth",

            block:"nearest"

        });

    };


/*==============================================================================*
*CLEAR
*==============================================================================*/

    const clearGI = ()=>{


        foodSelect.selectedIndex = 0;


        quantityInput.value = "";


        resultBox.innerHTML = "";


        resultBox.hidden = true;

    };


/*==============================================================================*
*EVENTS
*==============================================================================*/

    calculateButton.addEventListener(

        "click",

        calculateGI

    );


    clearButton.addEventListener(

        "click",

        clearGI

    );

}

};